"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_layer_1 = require("@pmi/analytics-layer");
var factory_1 = require("../../taskEventCreators/factory");
var utils_1 = require("../../utils");
var taskHandler = function (event, context) {
    if (event.eventType !== analytics_layer_1.EventTypes.Task || context.isHandled) {
        return;
    }
    var creator = (0, factory_1.getCreator)(event.eventName);
    if (!creator) {
        return;
    }
    var mainEventData = creator(event);
    (0, utils_1.pushEvent)(mainEventData);
    context.isHandled = true;
};
exports.default = taskHandler;
